import { identity } from 'lodash';

function sorterFactory(locale) {
  /**
   * A collator for sorting that has a sensitivity that only strings that differ in base letters compare as unequal
   * for more info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Collator
   */
  const collator = new Intl.Collator(locale, {
    usage: 'sort',
    sensitivity: 'base',
    numeric: true,
  });

  const isDate = d => d instanceof Date;

  const compare = (a, b) => {
    // If both objects are dates, convert to ISO form to allow correct sorting
    if (isDate(a) && isDate(b)) {
      return a.getTime() - b.getTime();
    }
    return collator.compare(a, b);
  };

  return {
    compare,
    sort: (items, order, valueGetter) => {
      const isDesc = order && order.toLowerCase() === 'desc';
      const getValue = valueGetter || identity;
      return [...items].sort((a, b) => {
        const aVal = getValue(a);
        const bVal = getValue(b);
        return isDesc ? compare(bVal, aVal) : compare(aVal, bVal);
      });
    },
  };
}

const defaultLocaleSorter = sorterFactory();

export default defaultLocaleSorter;
export { defaultLocaleSorter, sorterFactory };
